export default __webpack_public_path__ + "static/media/qr.dde31639.svg";